"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../toolkit/styling");

var _dimen = require("../../toolkit/dimen");

//
//  ResponsiveRow.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 4/1/20.
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */

/* Merchant Store */
var _default = (0, _mobxReact.observer)(function (props) {
  var className = props.className,
      style = props.style,
      children = props.children;
  var styles = useStylesheet();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, children);
});

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _DimenStore$instance = _dimen.DimenStore.instance(),
      isSmallScreen = _DimenStore$instance.isSmallScreen;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: isSmallScreen ? "column" : "row",
        alignItems: isSmallScreen ? "stretch" : "center"
      }
    });
  }, [isSmallScreen]);
};